module.exports = __webpack_public_path__ + "img/partner1.cc3cb4c0.png";